import { render, staticRenderFns } from "./layoutCollege.vue?vue&type=template&id=ab3f9ba8&"
import script from "./layoutCollege.vue?vue&type=script&lang=js&"
export * from "./layoutCollege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports